import * as React from 'react'
import ContactStage from './ContactStage'
import OthersStage from './OthersStage'
import { Divider } from '../../shared/Divider'

const FullFormAdditional = () => {

  return (
   <section className="tw-space-y-6 tw-p-6">
      <ContactStage  />
      <Divider />
      <OthersStage />
    </section>
  )
}

export default FullFormAdditional
